export class ExistError extends Error {
  constructor() {
    super('Данные уже существуют!');
    this.name = 'ExistError';
  }
}
